import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';
import * as moment from 'moment';

import { environment } from '../../environments/environment';
import { AuthService } from '../auth/auth.service';
import { Transfer } from '../transfers/transfer.model';
import { TransferFile } from '../transfers/transfer-file.model';
import { User } from '../users/user.model';

@Injectable()
export class DownloadsService {

  apiHost = environment.apiHost;
  signedIn: boolean = this.authService.signedIn;
  currentUser: User = this.authService.currentUser;

  constructor(
    private http: HttpClient,
    private authService: AuthService) { }

  getDownloads(): Observable<any> {
    let currentUser = this.authService.currentUser
    return this.http.get(this.apiHost+"/downloads").map(
      (data: any) => {
        let transfers = data.map((d) => {
          let transfer = Transfer.fromPackageRecord(d);
          // Workaround for API returning empty recipients
          if (transfer.recipients.length == 0) {
            transfer.recipients = [new User(currentUser)]
          }
          return transfer;
        })
        return transfers.reverse();
      }
    ).catch((error) => {
        console.log("Get downloads error:"); console.log(error);
        if (error.status === 401) {
          this.authService.signIn()
        }
        return Observable.throw(new Error(error.status));
      }
    );
  }

  getDownload(packageId: string): Observable<any> {
    let path = "/packages/" + packageId;
    return this.http.get(this.apiHost+path).map(
      (data: any) => {
        let transfer = Transfer.fromDeliveryRecord(data.deliveryHistory);
        return transfer;
      }
    ).catch((error) => {
        console.log("Get download error:"); console.log(error);
        if (this.signedIn && error.status === 401) {
          this.authService.signIn()
        }
        return Observable.throw(error.status);
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/downloads/downloads.service.ts